import React, { useRef, useState } from "react";
import Modal from "@/components/Modal";
import { useTranslation } from "@/langs/useTranslation";
import * as $ from "jquery";
import { ReactRender, ReactUnmount } from "@/components/ReactRender";
import styles from "@/containers/AndroidApp/index.module.less";
import * as dayjs from "dayjs";
import { Typography } from "@material-ui/core";
import { getAndroidAppList } from "@/apis/apiCollection";
import DataTable from "@/components/DataTable";
import Checkbox from "./UCCheckbox";

const AddAppModal = ({
  open,
  onClose,
  onConfirm,
  checked = {},
  enableSubVersion = true,
  single = false
}) => {
  const { t } = useTranslation();

  const ajaxData = useRef({});
  const expandData = useRef({});
  const checkList = useRef({ ...checked });
  const [multipleAppVersionErr, setMultipleAppVersionErr] = useState(false);

  // checkList.current = { ...checked };

  const handleBtnClick = (row, td) => {
    const isExpand = $(td).find("div").html() !== "+";
    $(td)
      .find("div")
      .html(isExpand ? "+" : "-");
    if (isExpand) collapse(row, td);
    else expand(row, td);
  };

  const handleConfirm = () => {
    const checked = checkList.current;
    const multiplePackageIdCheck = {};
    let multiplePackageIdErrFlag = false;
    Object.keys(checked).forEach(name => {
      const packageId = name.split("|||")[0];
      if (multiplePackageIdCheck[packageId]) {
        setMultipleAppVersionErr(true);
        multiplePackageIdErrFlag = true;
      } else multiplePackageIdCheck[packageId] = true;
    });
    if (multiplePackageIdErrFlag) return;
    const appList = Object.values(checked).filter(v => !!v);
    onConfirm(appList);
  };

  const handleClose = () => {
    setMultipleAppVersionErr(false);
    onClose?.();
  };

  const columns = [
    {
      name: "cb-tag",
      data: null,
      searchable: false,
      orderable: false,
      className: "center",
      createdCell: (td, data, row) => {
        ReactRender(
          <Checkbox
            single={single}
            data={checkList.current}
            name={`${row.package_id}|||${row.version}|||${row.id}`}
            rawData={{
              id: row.id,
              name: row.package_name,
              version: row.version,
              upload_at: row.uploaded_at,
              size: row.size,
              deleted_old: false,
              file_path: row.s3_path,
              md5: row.md5,
              package_id: row.package_id,
              version_code: row.version_code
            }}
          />,
          td
        );
      }
    },
    {
      name: "btn",
      data: null,
      searchable: false,
      orderable: false,
      className: "center",
      width: 10,
      visible: enableSubVersion,
      style: { padding: 0 },
      createdCell: (td, data, row) => {
        ReactRender(
          <div
            onClick={() => handleBtnClick(row, td)}
            className={styles.expandBtn}
            data-expand={false}
          >
            +
          </div>,
          td
        );
      }
    },
    {
      data: "package_name",
      title: t({ defaultMessage: "应用程序名称" }),
      searchable: false,
      orderable: false
    },
    {
      data: "package_id",
      title: t({ defaultMessage: "程序包ID" }),
      searchable: false,
      orderable: false
    },
    {
      data: "extension",
      title: t({ defaultMessage: "格式" }),
      searchable: false,
      orderable: false
    },
    {
      data: "version",
      title: t({ defaultMessage: "版本" }),
      searchable: false,
      orderable: false
    },
    {
      data: "version_code",
      title: t({ defaultMessage: "版本代码" }),
      searchable: false,
      orderable: false
    },
    {
      data: "size",
      title: t({ defaultMessage: "大小" }),
      searchable: false,
      orderable: false,
      render: data => `${(data / (1024 * 1024)).toFixed(2)} MB`
    },
    {
      data: "creator_name",
      title: t({ defaultMessage: "上传者" }),
      searchable: false,
      orderable: false
    },
    {
      data: "uploaded_at",
      title: t({ defaultMessage: "上传时间" }),
      searchable: false,
      orderable: false,
      render: data => {
        return dayjs(data).format("YYYY/MM/DD HH:mm:ss");
      }
    }
  ];

  const expand = (row, td) => {
    getAndroidAppList({
      ...ajaxData.current,
      page: 1,
      pageSize: 999,
      start: 0,
      length: 999,
      // ...getSearchParams(),
      target: "android",
      parent_id: row.id,
      order: [{ column: 6, dir: "asc" }]
    }).then(res => {
      const oldVersions = res.data;
      const $tr = $(td).parent();
      const newTrs = [];
      for (let i = 0; i < oldVersions.length; i++) {
        const newTr = $("<tr></tr>");
        $tr.after(newTr);
        newTrs.push(newTr[0]);
      }
      expandData.current[row.package_id] = newTrs;
      newTrs.forEach((tr, index) => {
        const oldData = oldVersions[index];
        oldData.deleted_old = false;
        ReactRender(
          <>
            {columns.map((column, ind) => {
              if (column.name === "btn") return <td key={ind} />;
              if (column.name === "cb-tag")
                return (
                  <td className={column.className} key={ind}>
                    <Checkbox
                      single={single}
                      data={checkList.current}
                      name={`${oldData.package_id}|||${oldData.version}|||${oldData.id}`}
                      // rawData={oldData}
                      rawData={{
                        id: oldData.id,
                        name: oldData.package_name,
                        version: oldData.version,
                        upload_at: oldData.uploaded_at,
                        size: oldData.size,
                        deleted_old: false,
                        file_path: oldData.s3_path,
                        md5: oldData.md5,
                        package_id: oldData.package_id,
                        version_code: oldData.version_code
                      }}
                    />
                  </td>
                );
              const data = oldData[column.data];
              return (
                <td className={column.className} key={ind}>
                  {column.render ? column.render(data) : data}
                </td>
              );
            })}
          </>,
          tr
        );
      });
    });
    // const a = $tr.insertAfter('tr')
  };

  const collapse = row => {
    const newTrs = expandData.current[row.package_id];
    if (newTrs) {
      newTrs.forEach(tr => {
        ReactUnmount(tr);
        $(tr).remove();
      });
    }
  };

  const ajax = (data, callback) => {
    ajaxData.current = data;
    return getAndroidAppList({
      ...data,
      target: "android",
      parent_id: "",
      order: [{ column: 9, dir: "desc" }]
    }).then(res => {
      callback({
        data: res.data,
        draw: data.draw,
        recordsFiltered: res.recordsTotal,
        recordsTotal: res.recordsTotal
      });
    });
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      onConfirm={handleConfirm}
      title={t({ defaultMessage: "选择应用" })}
      width={1200}
    >
      <DataTable
        ordering
        columns={columns}
        ajax={ajax}
        autoLoad
        // className={className}
        // style={style}
        // footer={footer}
        scrollable
        showCheckAll={false}
        // onLoaded={onLoaded}
      />
      {multipleAppVersionErr && (
        <Typography color="error">
          {t({ defaultMessage: "同一个应用只能选择一个版本" })}
        </Typography>
      )}
    </Modal>
  );
};

export default AddAppModal;
